import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, AlertCircle } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { DISCLAIMER } from '../constants';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loginWithAzure } = useApp();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // If already authenticated, redirect
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/upload');
    }
  }, [isAuthenticated, navigate]);

  const handleSSOLogin = async () => {
    setIsLoading(true);
    setError(null);
    try {
      await loginWithAzure();
      // 这里不写逻辑啦，因为 loginWithAzure 直接会执行 window.location.href 跳转走
    } catch (e: any) {
      setError('统一网关引导失败，请联系管理员');
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md border border-slate-200">
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-slate-900 rounded-xl flex items-center justify-center text-white mx-auto mb-4 shadow-lg">
            <Lock size={24} />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">LegalAI 法务助手</h1>
          <p className="text-slate-500 mt-2">使用企业统一身份登录</p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-rose-50 border border-rose-200 rounded-lg flex items-center gap-2 text-rose-700 text-sm">
            <AlertCircle size={16} />
            {error}
          </div>
        )}

        {/* SSO AD Login Button */}
        <button 
          onClick={handleSSOLogin}
          disabled={isLoading}
          className="w-full bg-[#0078d4] hover:bg-[#106ebe] text-white font-bold py-3 rounded-lg transition-all transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed mb-4 flex items-center justify-center gap-2"
        >
          <svg width="20" height="20" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
            <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          {isLoading ? '正在跳转至统一认证中心...' : '企业统一身份登录'}
        </button>


        <div className="mt-6 text-center">
          <p className="text-xs text-slate-400">由企业安全网关代理鉴权</p>
        </div>

        {/* Disclaimer */}
        <div className="mt-6 p-3 bg-amber-50 border border-amber-200 rounded-lg">
          <p className="text-xs text-amber-800">{DISCLAIMER.zh}</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
